import { Routes } from '@angular/router';
import { ModelSelectionComponent } from './components/model-selection/model-selection.component';
//TODO: Change spanish to english
export const IDEAL_CLIENT_ROUTES: Routes = [
  {
    path: '',
    component: ModelSelectionComponent
  },
  {
    path: 'oportunidad',
    loadComponent: () => import('./components/opportunities/opportunities.component').then(c => c.OpportunitiesComponent)
  },
  {
    path: 'oferta',
    loadComponent: () => import('./components/new-offers/new-offers.component').then(c => c.NewOffersComponent)
  },
  {
    path: 'financial-analysis',
    loadComponent: () => import('./components/financial-analysis/financial-analysis.component').then(c => c.FinancialAnalysisComponent)
  },
  {
    path: 'ml-combined-analysis',
    loadComponent: () => import('./components/ml-combined-analysis/ml-combined-analysis.component').then(c => c.MLCombinedAnalysisComponent)
 },
 {
    path: 'behavior-analysis',
    loadComponent: () => import('./components/behavior-analysis/behavior-analysis.component').then(c => c.BehaviorAnalysisComponent)
  },
  {
    path: 'final-summary',
    loadComponent: () => import('./components/final-summary/final-summary.component').then(c => c.FinalSummaryComponent)
  }

];